export const EmptyStates = {
  EmptyFolder: "This folder has no files",
  CheckOtherFolders: "Check other folders for files",
  AddReadme: "Add a README to this folder",
  ProvideInformation: "Provide information about the contents of this folder.",
  CreateReadme: "Create README",
  Skip: "Skip for now"
}
